import EmailNotificationsApi from '@/api/email-notifications/email-notifications';
import {getApiUrl} from '@/api/common-utils';
import {BaseApi} from '@/api/base-api';

export const EMAIL_NOTIFICATIONS_API = new EmailNotificationsApi(getApiUrl(BaseApi.LINKGRAPH_ENDPOINT, '/api'));
